import React, { Component } from "react";
import ProfileForm from "./ProfileForm";
import { Container, Header, HeaderTitle } from "./Styles/NewProfile.styles";

export default class NewProfile extends Component {
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (keywords, location) => {
    const { getSearchUrl, history } = this.props;
    const url = getSearchUrl(keywords, location);
    history.push(url);
  };

  render() {
    return (
      <Container className="TabbedPanelsContent TabbedPanelsContentVisible">
        <Header>
          <HeaderTitle>Profile</HeaderTitle>
        </Header>
        <ProfileForm {...this.props} action="create" />
      </Container>
    );
  }
}
